import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import store from "./store";
import "./theme/index.css";
import "font-awesome/css/font-awesome.min.css";
import '@/assets/css/index.scss' // global css 
import api from "./api";
import common from "./common/index.js";
import scroll from 'vue-seamless-scroll'

Vue.use(scroll)
Vue.use(ElementUI);

Vue.config.productionTip = false;

Vue.prototype.$goTo = function(name, query = {}) {
    router.push({ name, query: query });
}

// 时间格式化
Vue.filter('datetimeFormat', function (time,fmt = 'YYYY-MM-DD hh:mm:ss') {
    if (!time) return ''
    let date = new Date(time - 0)
    if (/(Y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, date.getFullYear() + '').substr(4 - RegExp.$1.length)
    }
    let o = {
        'M+': date.getMonth() + 1,
        'D+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let key in o) {
        if (new RegExp(`(${key})`).test(fmt)) {
        let str = o[key] + ''
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
        }
    }
    return fmt
})

Vue.prototype.$api = api; // 将api挂载到vue的原型上
Vue.prototype.$common = common; // 将公共变量挂载到vue的原型上

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
